import React from 'react'
import { Helmet } from 'react-helmet-async'

const Supports = () => {
  return (
    <div>
      <Helmet>
        <title> Support | EduSkills </title>
      </Helmet>
      Support
    </div>
  )
}

export default Supports

